module.exports = __webpack_public_path__ + "static/media/home.0d163736.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/maps/home.svg
// module id = 959
// module chunks = 0